var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isLoading)?_c('div',{staticClass:"loading-overlay"},[_c('b-spinner',{directives:[{name:"page-color",rawName:"v-page-color"}],attrs:{"label":"Loading..."}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }